const REDIRECT_TYPES = {
  GO_TO_CHECKOUT: "go-to-checkout",
};

export default REDIRECT_TYPES;
